import {PermissionCheck} from '@dofleini/security';
import React from 'react';

import {ExportComponent} from '@/components/ExportComponent';
import UserSelectionAction from '@/modules/admin/components/UserSelectionAction';
import {
  CACHE_KEY_LIST_USER,
  columns,
  filters,
  ROUTE_PATH_USER,
  SECURITY_KEY_USER,
  TRANSLATION_PREFIX_USER
} from '@/modules/admin/contants/users';
import UserApiService from '@/modules/admin/services/UserApiService';
import {i18n} from '@/settings';
import {createEntityContainer} from '@/utils/createEntityContainer';
import {getUserFullName} from '@/utils/userFullName';

export const {
  useList: useUserList,
  ContainerList: UserList,
  useTablePagination: useUserPagination
} = createEntityContainer(
  {
    module: CACHE_KEY_LIST_USER,
    service: UserApiService.search,
    route: ROUTE_PATH_USER,
    useCreatePath: true,
    translation: 'admin',
    entityName: SECURITY_KEY_USER,
    translationPrefix: TRANSLATION_PREFIX_USER,
    filters,
    columns,
    extras: <PermissionCheck permissions={'USER:EXPORT_EXCEL'}>
      <ExportComponent
        service={UserApiService.exportExcel}
        title={'user.export'}
        format={'.xlsx'}
        translation={'admin'}
        documentTitle={i18n.t('admin:user.exportFileName')}
      />
    </PermissionCheck>,
    breadcrumbName: getUserFullName,
    // eslint-disable-next-line react/display-name
    selectedActions: (itemsSelected) => <UserSelectionAction {...itemsSelected}/>
  }
);
